/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import NumberFormat from 'react-number-format';
import styles from './styles.module.scss';

import LinkLang from '../../Wraps/LinkLang';
import { ReactComponent as BagIcon } from '../../../assets/icons/icon-bag.svg';
import { ReactComponent as DeleteIcon } from '../../../assets/icons/icon-delete.svg';

import ApiProduct from '../../../api/Product';
import ApiCart from '../../../api/Cart/CartApiFL';
import { getCart } from '../../../redux/actions/cartActions';

import Config, { spanish } from '../../../config/config';

const Empty = () => (
  <div className={styles.empty}>
    <p>{spanish ? 'Tu bolsa está vacía' : 'Your bag is empty'}</p>
  </div>
);

const Item = ({ item, deleteCartItem, isInteractingWithMiniCart }) => {
  const [info, setInfo] = useState(null);
  const sku = parseFloat(item?.idProducto);
  useEffect(async () => {
    setInfo(await ApiProduct.getSKU(sku));
  }, [sku]);
  const isReady = info && info[0] && info[0]?.SLUG;
  return (
    <div className={styles.itemContainer}>
      <div className={styles.itemDelete}>
        <button
          type="button"
          onClick={() => {
            isInteractingWithMiniCart(true);
            deleteCartItem(item.idProducto);
          }}
        >
          <DeleteIcon />
        </button>
      </div>
      {isReady && (
        <LinkLang
          to={`/product/${info[0]?.SLUG}`}
          className={styles.itemContent}
          state={{ sku: item?.idProducto }}
        >
          <div className={styles.itemImage}>
            <img
              src={
                Config.cdn.cdn_path +
                info[0]?.imagesProduct[0]?.formats?.thumbnail?.url
              }
              alt={item.NombreProducto}
            />
          </div>
          <div className={styles.itemInfo}>
            <b>{info[0]?.Name}</b>
            <p>{`${spanish ? 'Cantidad' : 'Quantity'}: ${item.Cantidad}`}</p>
          </div>
          <div className={styles.itemPrice}>
            <b>
              <NumberFormat
                value={item?.Total}
                thousandSeparator
                prefix="$"
                suffix=" MXN"
                displayType="text"
              />
            </b>
          </div>
        </LinkLang>
      )}
    </div>
  );
};

const PopUp = ({ data, deleteCartItem, isInteractingWithMiniCart }) => (
  <div className={styles.popupContainer}>
    <div className={styles.popup}>
      <div className={styles.itemList}>
        {data?.DetalleCarrito?.map((item) => (
          <Item
            item={item}
            key={item.idProductoCarrito}
            deleteCartItem={deleteCartItem}
            isInteractingWithMiniCart={isInteractingWithMiniCart}
          />
        ))}
      </div>
      <div className={styles.popupBottom}>
        <p>SUBTOTAL:</p>
        <p>
          <NumberFormat
            value={data?.Total}
            thousandSeparator
            prefix="$"
            suffix=" MXN"
            displayType="text"
          />
        </p>
        <LinkLang to="/cart" className="btn btn-yellow">
          {spanish ? 'CONTINUAR' : 'CONTINUE'}
        </LinkLang>
      </div>
    </div>
  </div>
);

const MiniCart = ({ data }) => {
  const [showMinicart, setShowMinicart] = useState(false);
  const dispatch = useDispatch();
  if (data && data !== undefined)
    sessionStorage.setItem('localIdCart', data.idCarrito);
  const [isInteractingWithMiniCart, setIsInteractingWithMiniCart] = useState(
    false
  );
  const localIdCart = sessionStorage.getItem('localIdCart');
  useEffect(() => {
    if (localIdCart) dispatch(getCart(localIdCart));
  }, [localIdCart]);

  const currentCart = useSelector(
    (globalState) => globalState.cartInfo.InfoCarrito
  );
  const numItems =
    data && data.DetalleCarrito !== undefined
      ? data.DetalleCarrito?.map((el) => el.Cantidad).reduce((a, b) => a + b)
      : 0;

  const IdEstado = useSelector(
    (globalState) => globalState.estadoSelection.selectedEstadoId
  );
  const togglePopup = () => {
    setShowMinicart(!showMinicart);
  };
  const hidePopup = () => {
    setShowMinicart(false);
  };

  const deleteCartItem = async (productId) => {
    const currentCartDetail = currentCart[0].DetalleCarrito;
    const currentCartId = currentCart[0].idCarrito;
    const currentOfficeId = currentCart[0].idOficina;
    const filterProductToRemove = currentCartDetail.filter(
      (detail) => detail.idProducto === productId
    );

    const filterProductsToRemain = currentCartDetail.filter(
      (detail) => detail.idProducto !== productId
    );

    const mappedProductsToRemove = filterProductToRemove.map((product) => {
      const rObj = {};
      rObj.Cve_Prod = product.idProducto;
      rObj.Cantidad = 0;
      rObj.TipoUnidad = 'PI';
      return rObj;
    });

    const mappedProductsToRemain = filterProductsToRemain.map((product) => {
      const rObj = {};
      rObj.Cve_Prod = product.idProducto;
      rObj.Cantidad = product.Cantidad;
      rObj.TipoUnidad = 'PI';
      return rObj;
    });

    const finalCartProductArray = mappedProductsToRemain.concat(
      mappedProductsToRemove
    );

    const payload = {
      Cliente: Config.api_services.client,
      Pais: 'MEX',
      Ambiente: Config.api_services.environment,
      AgregarCarrito: {
        IdCarrito: currentCartId,
        IdEstado,
        TipoVenta: 1,
        FormaVenta: 3,
        IdFbo: 0,
        Productos: finalCartProductArray,
      },
    };

    const resp = await ApiCart.updateCart(payload);
    if (resp.Codigo === 200 || resp.Codigo === -1) {
      dispatch(getCart(resp.IdCarrito));
    }
  };

  return (
    <div className={styles.minicart}>
      <button type="button" onClick={togglePopup}>
        <BagIcon />
        <span>{numItems}</span>
      </button>
      <div
        className={`${styles.minicartPopup} ${
          showMinicart ? styles.minicartPopupActive : ''
        }`}
        onMouseLeave={hidePopup}
        onClick={hidePopup}
      >
        {data?.DetalleCarrito?.length > 0 ? (
          <PopUp
            data={data}
            deleteCartItem={deleteCartItem}
            isInteractingWithMiniCart={setIsInteractingWithMiniCart}
          />
        ) : (
          <Empty />
        )}
      </div>
    </div>
  );
};

export default MiniCart;
